import React from 'react'

const ErrorMessage = ({ message }) => {
  return (
    <div className='text-sm text-red-600 mt-2 font-normal'>{message}</div>
  )
}

export default ErrorMessage
